import React, { useState, useEffect, use } from 'react'
import { useMap, Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import { renderLat, renderLng, renderLatLng } from '../../utils/utils'

const UserPositionMarker = ({ position }) => {
  const map = useMap()
  //const [marker, setMarker] = useState(null)
  const [initiated, setInitiated] = useState(false)
  const [followMe, setFollowMe] = useState(localStorage.getItem('follow_mode') === 'true')
  const [myLatlng, setMyLatlng] = useState([])

  useEffect(() => {
    if (initiated) return
    setInitiated(true)
    map
      .locate({
        enableHighAccuracy: true,
        maximumAge: 30000,
        timeout: 10000,
        watch: true,
      })
      .on('locationfound', (e) => {
        const latlng = [e.latitude, e.longitude]
        setMyLatlng(latlng)
      })
      .on('locationmove', (e) => {
        const latlng = [e.latitude, e.longitude]
        setMyLatlng(latlng)
      })
      .on('locationerror', (e) => {
        setMyLatlng([])
      })
  }, [map])

  useEffect(() => {
    if (followMe && myLatlng.length > 0) {
      map.panTo(myLatlng)
    }
  }, [myLatlng, followMe])

  if (myLatlng.length === 0) {
    return null
  }

  return (
    <Marker
      position={myLatlng}
      icon={L.icon({
        iconUrl: '/img/geolocation-pin-red.png',
        iconSize: [14, 14],
        iconAnchor: [7, 14],
      })}
      autoPan={followMe}
    >
      <Popup className="navinfowindow" closeButton={true} closeOnClick={true}>
        <div>
          <div>
            <div>Sijaintisi:</div>
            <div>
              <div>{renderLat({ lat: myLatlng[0], lng: myLatlng[1] })}</div>
              <div>{renderLng({ lat: myLatlng[0], lng: myLatlng[1] })}</div>
            </div>
            <div>{myLatlng.map((num) => Number(num).toFixed(6)).join(', ')}</div>
            <input
              type="checkbox"
              id="followCheck"
              checked={followMe}
              onChange={(e) => {
                setFollowMe(e.target.checked)
                localStorage.setItem('follow_mode', e.target.checked)
              }}
            />
            <span>Seuraa sijaintia</span>
          </div>
        </div>
      </Popup>
    </Marker>
  )
}
export default UserPositionMarker
